var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7205 7.21348C15.0932 6.80174 15.0932 6.18413 14.7205 5.77239L9.68944 0.31683C8.81988 -0.643897 7.48447 0.797195 8.38509 1.75792L11.3354 4.98322C11.5839 5.25772 11.4907 5.46359 11.1491 5.46359L0.931677 5.46359C0.403726 5.46359 -3.09929e-07 5.90964 -2.84433e-07 6.49294C-2.58936e-07 7.07624 0.403726 7.52229 0.931677 7.52229L11.118 7.52229C11.4596 7.52229 11.5528 7.72816 11.3043 8.00265L8.35404 11.228C7.48447 12.1887 8.78882 13.6641 9.65839 12.669L14.7205 7.21348Z",
    fill: "#F7921E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.1502c65db652a19524f1182cea0773c2.svg";
export { ForwardRef as ReactComponent };